(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  // --- Pillar card expand (Calm / Smooth / Focused) ------
  function initPillarExpand() {
    const cards = $$('[data-pillar]');
    cards.forEach((card) => {
      const btn = card.querySelector('[data-pillar-toggle]');
      const panel = card.querySelector('.pillar-card__expand');
      if (!btn || !panel) return;
      const setOpen = (open) => {
        card.dataset.pillarOpen = open ? 'true' : 'false';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.setAttribute('aria-label', open ? 'Close details' : btn.getAttribute('aria-label').replace('Close details', 'Read more'));
        if (open) {
          panel.removeAttribute('hidden');
        } else {
          // Wait for fade-out before hiding to keep transition smooth
          setTimeout(() => {
            if (card.dataset.pillarOpen !== 'true') panel.setAttribute('hidden', '');
          }, 300);
        }
      };
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = card.dataset.pillarOpen === 'true';
        // Close any other open cards first
        cards.forEach((c) => {
          if (c !== card && c.dataset.pillarOpen === 'true') {
            const otherBtn = c.querySelector('[data-pillar-toggle]');
            c.dataset.pillarOpen = 'false';
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
        setOpen(!isOpen);
      });
      // ESC to close
      panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') setOpen(false);
      });
      // Click on the dark panel background closes
      panel.addEventListener('click', (e) => {
        if (e.target === panel) setOpen(false);
      });
      // "View full Supplement Facts" link inside an open card: close the card
      // and let the anchor scroll naturally to #supplement-facts.
      const closeLinks = panel.querySelectorAll('[data-pillar-close]');
      closeLinks.forEach((a) => {
        a.addEventListener('click', () => {
          setOpen(false);
          const sf = document.getElementById('supplement-facts-{{ section.id }}');
          if (sf && sf.tagName === 'DETAILS') sf.open = true;
        });
      });
    });
  }

  // --- Pillar carousel arrow nav (prev / next) ------
  function initPillarNav() {
    const sections = $$('.pillars');
    sections.forEach((section) => {
      const track = section.querySelector('[data-pillar-track]');
      const prevBtn = section.querySelector('[data-pillar-prev]');
      const nextBtn = section.querySelector('[data-pillar-next]');
      if (!track || !prevBtn || !nextBtn) return;

      const getCardWidth = () => {
        const firstCard = track.querySelector('[data-pillar]');
        if (!firstCard) return 0;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return firstCard.offsetWidth + gap;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initPillarExpand();
      initPillarNav();
    });
  } else {
    initPillarExpand();
    initPillarNav();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reveal-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Wait for DOM ready; section may load async in the theme editor
    function initRevealStrip(sectionEl) {
      if (!sectionEl) return;

      const buttons = Array.from(sectionEl.querySelectorAll('[data-reveal-flavor]'));
      if (!buttons.length) return;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var flavor = btn.dataset.revealFlavor;
          if (!flavor) return;

          // Update button states
          buttons.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-checked', active ? 'true' : 'false');
          });

          // Swap bag image
          var img = sectionEl.querySelector('[data-bag-image]');
          if (!img) return;
          var src = img.getAttribute('data-' + flavor);
          if (!src) return;
          img.classList.add('is-swapping');
          img.setAttribute('src', src);
          img.setAttribute('data-flavor', flavor);
          setTimeout(function () {
            img.classList.remove('is-swapping');
          }, 220);
        });
      });
    }

    // Init on page load
    document.querySelectorAll('[id^="reveal-"]').forEach(initRevealStrip);

    // Re-init when Shopify theme editor reloads a section
    document.addEventListener('shopify:section:load', function (e) {
      var sectionEl = e.target.querySelector('[id^="reveal-"]');
      if (sectionEl) initRevealStrip(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
